export const TIME_FORMAT = {
  MONTH: 'YYYYMM',
  DATE: 'YYYYMMDD',
  DATE_WITH_DASH: 'YYYY-MM-DD',
  DAY: 'DD',
  FULL_DATE: 'ddd DD-MMM-YYYY',
  WEEK_MONTH: 'dddd, Do MMMM',
  HOUR: 'HH:mm',
  HOUR_WITH_AM_PM: 'HH:mm A',
  HOUR_12: 'h:mm A',
  DATE_AND_TIME: 'YYYYMMDD HH:mm',
  ISO: 'YYYY-MM-DDTHH:mm:ss Z',
  FULL_TIME: 'YYYY-MM-DDTHH:mm:ss',
  TABLE_TIME: 'DD/MM/YYYY',
  TABLE_MONTH: 'MM/YYYY',
};
